import styled from "@emotion/styled";

export const ImagesWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "3/15",
  width: "100%",
  marginBlock: theme?.breakpoints?.isMobile ? 20 : "40px 30px",
}));

export const TwoColumsWrapper = styled.div(({theme}) => ({
  display: "grid",
  gridTemplateColumns: theme?.breakpoints?.isMobile ? "1fr" : "repeat(2, 1fr)",
  gridColumnGap: 20,
  gridRowGap: 20,
}));

export const Images = styled.img({
  gridColumn: "span 1",
  width: "100%",
  aspectRatio: "16/9",
  objectFit: "cover",
  borderRadius: 24,
});

export const Wrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "span 1",
  alignItems: "center",
  width: "100%",
  height: "auto",
  overflow: "hidden",
}));

export const SingleImage = styled.img(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "3/15",
  position: "relative",
  width: "100%",
  objectFit: "cover",
  aspectRatio: "16/9",
  borderRadius: 24,
}));
